import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import Button from "../common/Button";
import Modal from "../common/CustomModal";

import { linkWorkflows as linkWorkflowsRequest } from "../../actions/app";
import { getLinkWorkflowsLoading } from "../../selectors/app";
import "../../styles/settings.scss";

function LinkWorkflow(props) {
    const { workflowId, linkWorkflows, isLinkWorkflowsLoading } = props;

    const [openModal, setOpenModal] = useState(false);
    const [nextWorkflowId, setNextWorkflowId] = useState("");

    const showModal = () => setOpenModal(true);
    const closeModal = () => {
        setOpenModal(false);
        setNextWorkflowId("");
    };

    const onSuccess = () => {
        closeModal();
    };

    const onError = () => {
        // Error is already handled by Redux
    };

    const handleLinkWorkflow = () => {
        if (!nextWorkflowId.trim()) {
            alert("Please enter the next workflow ID");
            return;
        }

        linkWorkflows({
            currentWorkflowId: workflowId,
            nextWorkflowId,
            onSuccess,
            onError,
        });
    };

    return (
        <>
            <div className="tooltip">
                <div
                    onClick={showModal}
                    className="user-settings__btn"
                >
                    Add Id
                </div>
                <span className="tooltiptext">Link Workflow</span>
            </div>
            <Modal
                open={openModal}
                onClose={closeModal}
                center
                styles={{
                    modal: {
                        maxWidth: 500,
                    },
                }}
            >
                <p
                    style={{
                        fontSize: 20,
                        fontWeight: 600,
                        marginBottom: 16,
                    }}
                >
                    Link Workflow
                </p>
                <p style={{ marginBottom: 16 }}>
                    Enter the ID of the workflow you want to link as the next workflow.
                </p>
                <input
                    type="text"
                    value={nextWorkflowId}
                    onChange={(e) => setNextWorkflowId(e.target.value)}
                    placeholder="Enter next workflow ID"
                    style={{
                        width: "100%",
                        padding: "10px",
                        marginBottom: "20px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        fontSize: "14px",
                        boxSizing: "border-box",
                    }}
                />
                <div className="modal__btnbox">
                    <Button
                        size={"small"}
                        variant={"contained"}
                        style={{
                            marginLeft: 16,
                        }}
                        isLoading={isLinkWorkflowsLoading}
                        onClick={handleLinkWorkflow}
                    >
                        Link
                    </Button>
                    <Button
                        size={"small"}
                        variant={"outlined"}
                        onClick={closeModal}
                        disabled={isLinkWorkflowsLoading}
                    >
                        Cancel
                    </Button>
                </div>
            </Modal>
        </>
    );
}

LinkWorkflow.propTypes = {
    workflowId: PropTypes.string,
    linkWorkflows: PropTypes.func,
    isLinkWorkflowsLoading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
    isLinkWorkflowsLoading: getLinkWorkflowsLoading(),
});

const mapDispatchToProps = (dispatch) => ({
    linkWorkflows: (data) => dispatch(linkWorkflowsRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LinkWorkflow);
